import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconDownload = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "2px", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="currentColor"
        stroke={currentStroke}
        viewBox="0 0 24 24"
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 11.5858V6H11V11.5858L9.37377 9.95956L7.95956 11.3738L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L16.0404 11.3738L14.6262 9.95956L13 11.5858ZM7 14V16.6667C7 16.8508 7.14924 17 7.33333 17H16.6667C16.8508 17 17 16.8508 17 16.6667V14H19V16.6667C19 17.9553 17.9553 19 16.6667 19H7.33333C6.04467 19 5 17.9553 5 16.6667V14H7Z"
        />
      </svg>
    );
  }
);
